import styled from 'styled-components';

export const AlertBoxStyled = styled('div')(() => ({
  display: 'flex',
  width: 'fit-content',
  alignItems: 'center',
  padding: '8px 12px 8px 12px',
  background: 'rgba(255, 219, 161, 1)',
  border: '1px solid rgba(204, 86, 10, 1)',
  borderRadius: '4px',
  i: {
    fontSize: '24px',
  },
}));
